export default "assets/images/background-de9008fe.png";